import { render } from "./drawer.vue?vue&type=template&id=5d9f4ec7"
import script from "./drawer.vue?vue&type=script&lang=js"
export * from "./drawer.vue?vue&type=script&lang=js"

import "./drawer.vue?vue&type=style&index=0&id=5d9f4ec7&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__